/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 * Page Campaign Info lazy load
 *
 * @author Yakov Gushchin
 * @version 1.12.0
 * @since 1.12.0
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageCampaignInfo" */ './components/CampaignInfoPage'));
